import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "设备ID"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.device_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "device_id", $$v);
      },
      expression: "searchForm.device_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "备注"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "remark", $$v);
      },
      expression: "searchForm.remark"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "设备风险"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      multiple: ""
    },
    on: {
      change: _vm.handleRiskCodeChange
    },
    model: {
      value: _vm.searchForm.risk_code,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "risk_code", $$v);
      },
      expression: "searchForm.risk_code"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部风险",
      value: "1"
    }
  }), _vm._l(_vm.riskList, function (item) {
    return _c("el-option", {
      key: item.code,
      attrs: {
        label: item.name,
        value: item.code
      }
    });
  })], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "设备状态"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "正常",
      value: 0
    }
  }), _c("el-option", {
    attrs: {
      label: "高危标记设备",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "高危感知源",
      value: 2
    }
  }), _c("el-option", {
    attrs: {
      label: "高危Wi-Fi感知",
      value: 100
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "设备类别"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.category,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "category", $$v);
      },
      expression: "searchForm.category"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "拉客",
      value: 4
    }
  }), _c("el-option", {
    attrs: {
      label: "诈骗",
      value: 3
    }
  }), _c("el-option", {
    attrs: {
      label: "白嫖商家",
      value: 2
    }
  }), _c("el-option", {
    attrs: {
      label: "保持观察",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "空",
      value: 0
    }
  }), _c("el-option", {
    attrs: {
      label: "白名单",
      value: 5
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.time = [];
        _vm.searchForm = {
          status: ""
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "device_id",
      label: "设备ID",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.device_id || "暂无") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "mini_program_device_id",
      label: "小程序ID",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.mini_program_device_id || "暂无") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "status",
      label: "设备状态",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          staticClass: "deviceStatusTag"
        }, [scope.row.status == 0 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "success"
          }
        }, [_vm._v("正常")]) : _vm._e(), scope.row.status == 1 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "danger"
          }
        }, [_vm._v("高危标记设备 ")]) : _vm._e(), scope.row.status == 2 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "danger"
          }
        }, [_vm._v("高危感知源 " + _vm._s(scope.row.status_remark ? "\uFF1A".concat(scope.row.status_remark) : ""))]) : _vm._e(), scope.row.perception_code != "" ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "warning"
          }
        }, [_vm._v("高危Wi-Fi感知 " + _vm._s(scope.row.perception_code ? "\uFF1A".concat(_vm.perceptionCode[scope.row.perception_code]) : "") + " ")]) : _vm._e()], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "关联用户",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfoList = _ref.row.userInfoList;
        return [_vm._l(userInfoList, function (item, index) {
          return _c("div", {
            key: item.id
          }, [index <= 9 ? _c("wlc-user-pop", {
            attrs: {
              info: item,
              page: "device"
            },
            on: {
              saveRemark: _vm.saveRemark
            }
          }) : _vm._e()], 1);
        }), userInfoList.length >= 10 ? _c("el-button", {
          attrs: {
            type: "primary",
            plain: "",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.moreUser(userInfoList);
            }
          }
        }, [_vm._v("更多")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      prop: "relevance_user_count",
      sortable: "",
      label: "关联用户数"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "risk_code_name",
      label: "设备风险"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.risk_code.length == 0 ? _c("el-tag", {
          attrs: {
            size: "small",
            type: "success"
          }
        }, [_vm._v("无")]) : _vm._e(), _vm._l(scope.row.risk_code_name || [], function (item) {
          return _c("el-tag", {
            key: item,
            attrs: {
              size: "small",
              type: "warning"
            }
          }, [_vm._v(_vm._s(item))]);
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "category",
      label: "类别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.category === 0 ? _c("span") : _vm._e(), scope.row.category === 1 ? _c("span", [_vm._v("保持观察")]) : _vm._e(), scope.row.category === 2 ? _c("span", [_vm._v("白嫖商家")]) : _vm._e(), scope.row.category === 3 ? _c("span", [_vm._v("诈骗")]) : _vm._e(), scope.row.category === 4 ? _c("span", [_vm._v("拉客")]) : _vm._e(), scope.row.category === 5 ? _c("span", [_vm._v("白名单")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "remark",
      label: "备注",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.remark_log,
            remark: scope.row.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "版本信息",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.user_list.length > 0 ? _c("wlc-app-version", {
          attrs: {
            info: scope.row.user_list[0]["newest_app_info"] || scope.row.user_list[0]["app_info"] || {}
          }
        }) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "relevance_user_updated_at",
      sortable: "",
      label: "用户数更新时间",
      width: "155"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "updated_at",
      sortable: "",
      width: "105",
      label: "更新时间"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "created_at",
      width: "95",
      label: "创建时间"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      fixed: "right",
      width: "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == 0 && scope.row.device_id != "000000000000000000000000000000000000" ? _c("el-button", {
          staticStyle: {
            color: "#e8951a"
          },
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setDanger(scope.row);
            }
          }
        }, [_vm._v("设高危设备")]) : _vm._e(), scope.row.device_id != "000000000000000000000000000000000000" ? _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setCategory(scope.row);
            }
          }
        }, [_vm._v("类别")]) : _vm._e(), scope.row.status == 1 && scope.row.device_id ? _c("el-button", {
          staticStyle: {
            color: "#e04040"
          },
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.openSource(scope.row);
            }
          }
        }, [_vm._v("设感知源")]) : _vm._e(), scope.row.status == 2 ? _c("el-button", {
          staticStyle: {
            color: "#000000"
          },
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.removeSource(scope.row);
            }
          }
        }, [_vm._v("移除感知源")]) : _vm._e(), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.remark(scope.row);
            }
          }
        }, [_vm._v("备注")]), scope.row.status == 1 ? _c("el-button", {
          staticStyle: {
            color: "#000000"
          },
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.removeDanger(scope.row);
            }
          }
        }, [_vm._v("移除高危")]) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.count,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "选择数据库",
      visible: _vm.dialogFormVisible,
      width: "480px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "请选择数据库"
    },
    model: {
      value: _vm.perception_database_id,
      callback: function callback($$v) {
        _vm.perception_database_id = $$v;
      },
      expression: "perception_database_id"
    }
  }, _vm._l(_vm.sourceList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.dialogFormVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.setSource
    }
  }, [_vm._v("确 定")])], 1)], 1), _c("el-dialog", {
    attrs: {
      title: "提示",
      visible: _vm.dangerDialogVisible,
      width: "30%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dangerDialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "margin-top": "-20px",
      "margin-bottom": "30px"
    }
  }, [_c("i", {
    staticClass: "el-icon-warning",
    staticStyle: {
      color: "#e6a23c",
      "margin-right": "10px"
    }
  }), _c("span", [_vm._v("设置高危设备, 是否继续?")])]), _c("div", {
    staticClass: "setDanger"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v(" 类别 "), _c("span", [_vm._v("（非必选）")])]), _c("el-radio-group", {
    model: {
      value: _vm.category,
      callback: function callback($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 4
    }
  }, [_vm._v("拉客")]), _c("el-radio", {
    attrs: {
      label: 3
    }
  }, [_vm._v("诈骗")]), _c("el-radio", {
    attrs: {
      label: 2
    }
  }, [_vm._v("白嫖商家")]), _c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("保持观察")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("空")])], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.dangerDialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.setDangerConfirm
    }
  }, [_vm._v("确 定")])], 1)]), _c("el-dialog", {
    attrs: {
      title: "类别",
      visible: _vm.categoryDialogVisible,
      width: "30%"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.categoryDialogVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "setDanger"
  }, [_c("el-radio-group", {
    model: {
      value: _vm.category,
      callback: function callback($$v) {
        _vm.category = $$v;
      },
      expression: "category"
    }
  }, [_c("el-radio", {
    attrs: {
      label: 4
    }
  }, [_vm._v("拉客")]), _c("el-radio", {
    attrs: {
      label: 3
    }
  }, [_vm._v("诈骗")]), _c("el-radio", {
    attrs: {
      label: 2
    }
  }, [_vm._v("白嫖商家")]), _c("el-radio", {
    attrs: {
      label: 1
    }
  }, [_vm._v("保持观察")]), _c("el-radio", {
    attrs: {
      label: 0
    }
  }, [_vm._v("空")]), _c("el-radio", {
    attrs: {
      label: 5
    }
  }, [_vm._v("白名单")])], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.categoryDialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary",
      disabled: _vm.category === "" || _vm.category === null || _vm.category === undefined
    },
    on: {
      click: _vm.setCategoryConfirm
    }
  }, [_vm._v("确 定")])], 1)]), _c("el-dialog", {
    staticClass: "more-user-dialog",
    attrs: {
      title: "关联用户",
      visible: _vm.moreUserDialogVisible,
      width: "800px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.moreUserDialogVisible = $event;
      }
    }
  }, [_c("div", [_c("el-table", {
    attrs: {
      data: _vm.moreUserList,
      height: "250"
    }
  }, [_c("el-table-column", {
    attrs: {
      property: "name",
      label: "姓名",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-user-pop", {
          attrs: {
            info: scope.row,
            page: "device"
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      property: "phone",
      label: "手机号",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "用户最近标签"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-user-table-tag", {
          attrs: {
            userId: scope.row.id,
            mode: "simple",
            list: scope.row.userTag
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      property: "created_at",
      label: "注册时间",
      width: "150"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("span", {
    staticStyle: {
      "font-size": "14px",
      "margin-right": "10px"
    }
  }, [_vm._v("共 " + _vm._s(_vm.moreUserList.length) + " 条")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.moreUserDialogVisible = false;
      }
    }
  }, [_vm._v("关 闭")])], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };